import { CLEAR_TALENT_INFO_VCARD, SET_TALENT_INFO_VCARD } from './../constants';

const initialState = {
  id: '',
  internalIds: [],
  name: '',
  filter: 'all',
  roles: [],
};

export const talentInfoVcard = (state = initialState, action) => {
  switch (action.type) {
    case SET_TALENT_INFO_VCARD:
      return {
        ...state,
        id: action.payload.id,
        internalIds: action.payload.internalIds,
        name: action.payload.name,
        roles: [...action.payload.roles],
      };
    case CLEAR_TALENT_INFO_VCARD:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default talentInfoVcard;
